/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	OrganisationAtsAutomationSettingsUpdatePathParams,
	OrganisationAtsAutomationSettingsUpdateRequest,
	OrganisationAtsAutomationSettingsUpdateResponse,
} from '../types/OrganisationAtsAutomationSettingsUpdate'

/**
 * PUT /organisations/:organisation/ats-automation-settings
 * @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationAtsAutomationSettingsController.php OrganisationAtsAutomationSettingsController::update
 */
export async function organisationAtsAutomationSettingsUpdate(
	organisation: OrganisationAtsAutomationSettingsUpdatePathParams['organisation'],
	data: OrganisationAtsAutomationSettingsUpdateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganisationAtsAutomationSettingsUpdateResponse>> {
	return axiosInstance.put(`/organisations/${organisation}/ats-automation-settings`, data, config)
}
